import React from 'react';
import dotenv from 'dotenv';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import {
  ApolloProvider,
  InMemoryCache,
  ApolloClient,
  createHttpLink,
} from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { Provider } from 'react-redux';
import store from 'src/store';
import App from './App';
import * as serviceWorker from './serviceWorker';
import "./theme/index.css";


dotenv.config();
export const GRAPHQL_URL = process.env.REACT_APP_GRAPHQL_URL; // https://peekwire.com/api/gql //'https://ewings.lk/api/gql'; //'http://104.198.26.221/api/graphql'; // 'https://ewings.lk/api/graphql';
const httpLink = createHttpLink({
  uri: GRAPHQL_URL,
});

const authLink = setContext((_, { headers }) => {
  // get the authentication token from local storage if it exists
  const token = localStorage.getItem('accessToken');
  // return the headers to the context so httpLink can read them
  return {
    headers: {
      ...headers,
      authorization: token ? `${token}` : '',
    },
  };
});

const client = new ApolloClient({
  cache: new InMemoryCache(),
  link: authLink.concat(httpLink),
});

ReactDOM.render(
  <ApolloProvider client={client}>
    <Provider store={store}>
      <BrowserRouter>
        <App />
      </BrowserRouter>
    </Provider>
  </ApolloProvider>,

  document.getElementById('root')
);

serviceWorker.unregister();
